<template>
  <section>
    <h2>Match Watched Films to TMDB</h2>

    <div class="matcher">
      <ul class="film-list">
        <li v-for="film in watchedFilms" :key="film.filmId">
          <button type="button" @click="selectFilm(film)">
            {{ film.title }} ({{ film.year }})
          </button>
        </li>
      </ul>

      <div v-if="selectedFilm" class="result">
        <h3>{{ selectedFilm.title }} ({{ selectedFilm.year }})</h3>

        <p v-if="loading">Searching TMDB…</p>
        <p v-else-if="error">{{ error }}</p>

        <div v-else-if="searchResult">
          <img
            v-if="searchResult.posterUrl"
            :src="searchResult.posterUrl"
            :alt="searchResult.title"
            width="150"
          />
          <p><strong>{{ searchResult.title }}</strong></p>
          <p>{{ searchResult.releaseDate }}</p>
          <p>{{ searchResult.overview }}</p>
          <p>TMDB ID: {{ searchResult.tmdbId }}</p>

          <button type="button" :disabled="saving" @click="approve">Approve</button>
          <button type="button" :disabled="saving" @click="deny">Deny</button>

          <p v-if="savedMessage">{{ savedMessage }}</p>
        </div>

        <p v-else>No TMDB match found.</p>
      </div>
    </div>
  </section>
</template>

<script setup>
const watchedFilms = ref([])
const selectedFilm = ref(null)
const searchResult = ref(null)
const loading = ref(false)
const saving = ref(false)
const error = ref('')
const savedMessage = ref('')

const { data } = await useFetch('/api/watched-films')
watchedFilms.value = data.value ?? []

async function selectFilm(film) {
  selectedFilm.value = film
  searchResult.value = null
  error.value = ''
  savedMessage.value = ''
  loading.value = true

  try {
    searchResult.value = await $fetch('/api/tmdb-search', {
      query: { title: film.title }
    })
  } catch (err) {
    error.value = err?.data?.statusMessage || 'TMDB search failed.'
  } finally {
    loading.value = false
  }
}

async function approve() {
  if (!selectedFilm.value || !searchResult.value) return

  saving.value = true
  savedMessage.value = ''
  error.value = ''

  try {
    await $fetch('/api/films', {
      method: 'POST',
      body: {
        oclId: selectedFilm.value.filmId,
        title: searchResult.value.title,
        overview: searchResult.value.overview,
        releaseDate: searchResult.value.releaseDate,
        posterUrl: searchResult.value.posterUrl,
        tmdbId: searchResult.value.tmdbId
      }
    })
    savedMessage.value = `Saved "${searchResult.value.title}" to Strapi.`
  } catch (err) {
    error.value = err?.data?.statusMessage || 'Failed to save film to Strapi.'
  } finally {
    saving.value = false
  }
}

function deny() {
  selectedFilm.value = null
  searchResult.value = null
}
</script>

<style scoped>
.matcher {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.film-list {
  list-style: none;
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
}

.film-list button {
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  padding: 0.25rem 0;
}

.result {
  min-width: 250px;
}
</style>
